/******************
 * Vinova Themes  Framework for Prestashop 1.7.x 
 * @package    Nova - PrestaShop 1.7 Theme For Fashion Templates
 * @version    1.0
 * @author    http://vinovathemes.com/
 * @copyright  Copyright (C) October 2013 vinovathemes.com <@emai:vinovathemes@gmail.com>
 * <info@vinovathemes.com>.All rights reserved.
 * @license   GNU General Public License version 1
 * *****************/
/*
 
 
 * A template should always ship with an empty custom.js
 */
$('.videos-slider-2').slick({
  autoplay: false,
  slidesToScroll: 1,
  slidesToShow: 1,
  arrows: false,
  dots: false,
  asNavFor: '.slider-nav-thumbnails',
});

$('.slider-nav-thumbnails').slick({
  autoplay: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  asNavFor: '.videos-slider-2',
  arrows: true,
  dots: false,
  focusOnSelect: true,
  variableWidth: true
});

// Remove active class from all thumbnail slides
$('.slider-nav-thumbnails .slick-slide').removeClass('slick-active');

// Set active class to first thumbnail slides
$('.slider-nav-thumbnails .slick-slide').eq(0).addClass('slick-active');

// On before slide change match active thumbnail to current slide
$('.videos-slider-2').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
  var mySlideNumber = nextSlide
   $('.slider-nav-thumbnails .slick-slide').removeClass('slick-active');
  $('.slider-nav-thumbnails .slick-slide').eq(mySlideNumber).addClass('slick-active');
});

